import React from "react";
import { FaWhatsapp } from "react-icons/fa";
import "./FloatingChat.css";

const FloatingChat: React.FC = () => {
  const openWhatsApp = () => {
    window.open("https://wa.me/5521936185311", "_blank");
  };

  return (
    <div className="floating-chat">
      <button 
        className="floating-chat-button" 
        onClick={openWhatsApp}
        aria-label="Falar no WhatsApp"
      >
        <FaWhatsapp className="floating-chat-icon" />
      </button>
    </div>
  );
};

export default FloatingChat;